module.exports = __webpack_public_path__ + "img/main-bg.0804cd28.png";